import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { colFlexStyle, commonContainerWrapper } from "../../Common/styles/flex";
import { useParams } from "react-router-dom";
import { AxiosResponse } from "axios";
import http from "../../../utils/http";
import { errorToastMessage } from "../../../utils/toast";

const ParticipantDetails = () => {
  const [data, setData] = useState<any>([]);
  const { participantId } = useParams();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let url = `/platform/participants/${participantId}`;

        const res: AxiosResponse = await http.get(url);
        const resData = res?.data?.data;
        setData(resData);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        errorToastMessage(err as Error);
      }
    };
    fetchData();
  }, [participantId]);

  return (
    <Box>
      <Box sx={commonContainerWrapper}>
        <Typography fontSize={20} fontWeight={500} color="text.primary">
          Participant Details
        </Typography>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              my: 4,
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 5,
              my: 3,
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                <Typography fontSize={16} fontWeight={500} color="text.primary">
                  First Name
                </Typography>
                <Typography fontSize={16} fontWeight={400} color="text.primary">
                  {data?.firstName || "-"}
                </Typography>
              </Box>
              <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                <Typography fontSize={16} fontWeight={500} color="text.primary">
                  Last Name
                </Typography>
                <Typography fontSize={16} fontWeight={400} color="text.primary">
                  {data?.lastName || "-"}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                <Typography fontSize={16} fontWeight={500} color="text.primary">
                  Email
                </Typography>
                <Typography fontSize={16} fontWeight={400} color="text.primary">
                  {data?.email || "-"}
                </Typography>
              </Box>
              <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                <Typography fontSize={16} fontWeight={500} color="text.primary">
                  Phone Number
                </Typography>
                <Typography fontSize={16} fontWeight={400} color="text.primary">
                  {data?.phoneNumber || "-"}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
              <Typography fontSize={16} fontWeight={500} color="text.primary">
                Gender
              </Typography>
              <Typography fontSize={16} fontWeight={400} color="text.primary">
                {data?.gender || "-"}
              </Typography>
            </Box>
            <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
              <Typography fontSize={16} fontWeight={500} color="text.primary">
                DOB
              </Typography>
              <Typography fontSize={16} fontWeight={400} color="text.primary">
                {data?.dob || "-"}
              </Typography>
            </Box>
            <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
              <Typography fontSize={16} fontWeight={500} color="text.primary">
                Occupation
              </Typography>
              <Typography fontSize={16} fontWeight={400} color="text.primary">
                {data?.occupation || "-"}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                <Typography fontSize={16} fontWeight={500} color="text.primary">
                  Address Line 1
                </Typography>
                <Typography fontSize={16} fontWeight={400} color="text.primary">
                  {data?.address?.line1 || "-"}
                </Typography>
              </Box>
              <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                <Typography fontSize={16} fontWeight={500} color="text.primary">
                  Address Line 2
                </Typography>
                <Typography fontSize={16} fontWeight={400} color="text.primary">
                  {data?.address?.line2 || "-"}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                <Typography fontSize={16} fontWeight={500} color="text.primary">
                  City
                </Typography>
                <Typography fontSize={16} fontWeight={400} color="text.primary">
                  {data?.address?.city || "-"}
                </Typography>
              </Box>
              <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                <Typography fontSize={16} fontWeight={500} color="text.primary">
                  State
                </Typography>
                <Typography fontSize={16} fontWeight={400} color="text.primary">
                  {data?.address?.state || "-"}
                </Typography>
              </Box>
              <Box sx={{ ...colFlexStyle, minWidth: "240px", gap: "10px" }}>
                <Typography fontSize={16} fontWeight={500} color="text.primary">
                  Country
                </Typography>
                <Typography fontSize={16} fontWeight={400} color="text.primary">
                  {data?.address?.country || "-"}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ParticipantDetails;
